var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.handleItem
      ? _c("div", { staticClass: "invisible" }, [
          _vm.handleItem.type === "drinkOrder"
            ? _c(
                "div",
                [
                  _c("div", [_vm._v("DrinkItemDetail")]),
                  _c("DrinkItemDetail", {
                    attrs: { itemId: _vm.handleItem.id, addDirectly: true },
                    on: { wasAdded: _vm.finish },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.handleItem.type === "foodOrder"
            ? _c(
                "div",
                [
                  _c("div", [_vm._v("DrinkItemDetail")]),
                  _c("ItemDetail", {
                    attrs: { itemId: _vm.handleItem.id, addDirectly: true },
                    on: { wasAdded: _vm.finish },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }